<template>
    <div class="default-body customer-qw-wrap">
        <!-- 查询条件 -->
        <el-form :inline="true" :model="searchForm" class="mb-4">
            <el-form-item label="订单号">
                <el-input v-model="searchForm.orderNumber" placeholder="请输入订单号"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" size="mini" icon="el-icon-search" @click="fetchData">查询</el-button>
                <el-button type="success" size="mini" icon="el-icon-plus" @click="add()">新增记录</el-button>
                <el-input v-model="userLink" aria-readonly="true" placeholder="用户连接"></el-input>
                <el-button type="primary" size="mini" icon="el-icon-document-copy" @click="copyUserLink">复制连接</el-button>
            </el-form-item>
        </el-form>

        <!-- 数据表格 可编辑表格 -->
        <tablePagination :total="total" :pageSize="searchForm.pageSize" @handlePage="handlePageChange">
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column prop="id" label="标识" width="120"/>
                <el-table-column prop="orderNumber" label="订单号" width="160">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.orderNumber"  placeholder="请输入ERP订单号"/>
                    </template>
                </el-table-column>

                <el-table-column prop="trackingNumber" label="物流单号" width="160"/>
                <el-table-column prop="orderRemark" label="订单备注"/>
                <el-table-column prop="nickName" label="用户昵称"/>
                <el-table-column prop="userRemark" label="用户备注"/>
                <el-table-column prop="userName" label="BD"/>
                <el-table-column prop="createTime" label="创建时间" width="180"/>
                <el-table-column prop="updateTime" label="更新时间" width="180"/>
                <el-table-column label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="saveRecord(scope.row)">保存</el-button>
                        <el-button size="mini" type="danger" @click="deleteRecord(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </tablePagination>

        <!-- 弹窗表单 -->
        <el-dialog :title="form.id ? '编辑记录' : '新增记录'" :visible.sync="dialogVisible">
            <el-form :model="form" label-width="100px" ref="formRef">
                <el-form-item label="订单号" required>
                    <el-input v-model="form.orderNumber" :disabled="!!form.id" placeholder="请输入ERP订单号"/>
                </el-form-item>
                <el-form-item label="物流单号">
                    <el-input v-model="form.trackingNumber" placeholder="请输入物流单号"/>
                </el-form-item>
                <el-form-item label="订单备注">
                    <el-input v-model="form.orderRemark" type="textarea"/>
                </el-form-item>
                <el-form-item label="用户备注">
                    <el-input v-model="form.userRemark" type="textarea"/>
                </el-form-item>
                <!-- <el-form-item label="客户ID" required>
                  <el-input v-model="form.customerId" placeholder="请输入客户ID"/>
                </el-form-item>
                <el-form-item label="服务人员ID" required>
                  <el-input v-model="form.qyWeixinUserId" placeholder="请输入服务人员企业微信ID"/>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveRecord">保存</el-button>

            </div>
        </el-dialog>
    </div>
</template>

<script>

import {wxQw} from "@/api/wxQwConfig";

let wx = window.wx
let qwPlatform = navigator.userAgent.indexOf('wxwork')>-1?true:false

export default {
    name: 'OrderLogistics',
    data() {
        return {
            searchForm: {
                orderNumber: '',
                customerId: '',
                qyWeixinUserId: '',
                pageSize: 10,
                currentPage: 1,
            },
            qwPlatform,
            userLink:'',
            tableData: [],
            total: 0,

            dialogVisible: false,
            form: {
                id:'',
                orderNumber: '',
                trackingNumber: '',
                orderRemark: '',
                userRemark: '',
                customerId: '',
                qyWeixinUserId: ''
            }
        }
    },
    mounted() {
        if(qwPlatform){
            wxQw().then(()=>{
                if(this.form.customerId != ''){
                    this.fetchData()
                }else{
                    console.log('获取当前外部联系人信息')
                    wx.invoke('getCurExternalContact', {}, (res)=>{
                        if (res.err_msg == 'getCurExternalContact:ok') {
                            let userInfo = res;
                            console.log('userInfo',userInfo)
                            this.form.customerId = userInfo.userId;
                            console.log('customerId',userInfo.userId)
                            this.fetchData()
                        } else {
                            this.form.customerId="";
                        }
                    })
                }
            })
        }else{
            console.log(121212)
            this.fetchData()
        }

    },
    methods: {
        fetchData() {
            this.$apiGet('lechun-cms/scrmOrder/getList', { ...this.searchForm }).then(res => {
                console.log(res)
                this.total = res.total|| 0;
                this.tableData = res.list|| []
                console.log('tableData', this.tableData)
                if(this.tableData[0].customerId && this.tableData[0].userid) {
                    this.fetchUserLink(this.tableData[0].userid, this.tableData[0].customerId)
                }
            })
        },
        fetchUserLink(userid, customerId) {
            console.log('fetchUserLink', userid, customerId)
            if(!userid || !customerId) {
                this.$message.error('用户ID或客户ID不能为空')
                return
            }
            this.userLink='https://csms.lechun.cc/scrmOrderUser?userid=' + userid + '&customerId=' + customerId
            console.log(this.userLink)
        },
        handlePageChange(page) {
            this.searchForm.currentPage = page
            this.fetchData()
        },
        add() {
            this.form = {
                id: '',
                orderNumber: '',
                trackingNumber: '',
                orderRemark: '',
                userRemark: '',
                customerId: this.form.customerId
            }
            this.tableData.push(this.form)
        },
        copyUserLink() {
            if (!this.userLink) {
                this.$message.error('没有可复制的用户连接');
                return;
            }
            navigator.clipboard.writeText(this.userLink).then(() => {
                this.$message.success('用户连接已复制到剪贴板');
            }).catch(err => {
                console.error('复制失败:', err);
                this.$message.error('复制失败');
            });
        },
        //删除
        deleteRecord(row) {
            this.$confirm('是否确认删除该记录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$apiGet('lechun-cms/scrmOrder/delete', { id: row.id }).then(() => {
                    this.$message.success('删除成功')
                    this.fetchData()
                })
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },
        saveRecord(row) {
            const isUpdate = !!this.form.id
            if(!this.form.orderNumber) {
                this.$message.error('订单号不能为空')
                return
            }
            this.form.id = row.id || ''
            this.$apiPost('lechun-cms/scrmOrder/save', this.form).then(() => {
                this.$message.success(isUpdate ? '更新成功' : '新增成功')
                this.dialogVisible = false
                this.fetchData()
            })
        }
    }
}
</script>

<style scoped lang="scss">
.mb-4 {
    margin-bottom: 20px;
}
.mt-4 {
    margin-top: 20px;
}
.customer-qw-wrap{
    background: #f2f2f2;
    height: 100%;
    overflow: auto;
    p{
        margin: 2px;
    }
    .el-tabs__item{
        font-size: 10px;
        padding: 0 8px;
    }
    .el-select-dropdown{
        left: 0!important;
    }
    .el-form-item__content {
        font-size: 12px;
    }

    .el-form-item__label {
        color: #795da3;
        font-size: 13px;
    }

    .el-form-item--mini.el-form-item {
        margin-bottom: 8px;
    }

    .el-input {
        width: 99%;
    }
    .el-descriptions__header{
        margin-bottom: 9px;
    }
    .el-tabs--border-card{
        background: #ffffff;
        box-shadow: none;
        border: none;
    }
    .el-descriptions-item__label.is-bordered-label{
        background: #ffffff;
        color: #000000;
    }
    .el-tabs--border-card > .el-tabs__content{
        padding: 10px;
        border-left:2px solid #f2f2f2;
        box-sizing: border-box;
    }

    .label-style{
        width: 85px;
    }
    .copy-text{
        white-space: pre-line;
        margin: 0;
        line-height: 18px;
        background: #f2f2f2;
        border: 1px solid #e8e8e8;
        border-radius: 5px;
        padding: 6px;
        max-height: 130px;
        overflow-y: scroll;
        scrollbar-width: none;
    }
    .mini-item{
        //display: flex;
        //justify-content: space-between;
        //align-items: center;
        border-bottom: 1px solid #dfdfdf;
        padding: 10px 0;
        .mini-item-check{
            font-size: 20px;
            color: #999999;
        }
        img{
            width: 40px;
            height: 40px;
            display: block;
            margin: 0 12px 0 16px;
        }
        .mini-item-title{
            font-weight: bolder;
            margin-right: 8px;
            font-size: 12px;
        }
        .mini-item-content{
            flex: 1;
            font-size: 12px;
            padding-top: 3px;
        }
        .mini-item-time{
            font-size: 10px;
            color: #999999;
            text-align: right;
            margin-top: 5px;
        }
        .mini-item-submit{
            //color: #1bb263;
            //font-size: 22px;
            margin: 0 10px;
        }
        .mini-item-ai-btn{
            font-size: 10px;
            margin: 0 5px;
        }
    }
}
</style>
